import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  ADD_AGENDA_SOLUTION_FOLLOWER,
  LOGIN_NOT_AGENDA_SOLUTIONS_CLOSE_LOGIC,
} from 'manager/http-constants';
import { AuthorityDecision } from 'manager/user-authority-constant';
import { MESSAGE_CODE } from 'src/app/shared/constant/message-constant';
import { LoadingState } from 'src/app/shared/html-parts/loading/loading-state';
import { CommonService } from 'src/app/shared/service/common.service';
import { DbOperationService } from 'src/app/shared/service/db-operation.service';
import { LoginService } from 'src/app/shared/service/login.service';
import { PlatformComponent } from '../platform.component';
import { API_RESPONSE } from 'src/app/shared/constant/api-constant';
import { observable } from 'rxjs';

@Component({
  selector: 'redirect',
  templateUrl: './main-redirect.component.html',
  styleUrls: ['./main-redirect.component.scss', '../platform.component.scss'],
})

/**
 * マイページ
 */
export class MainRedirectComponent extends PlatformComponent {
  constructor(
    public route: ActivatedRoute,
    public commonService: CommonService,
    public dbOperationService: DbOperationService,
    public loadingState: LoadingState,
    private router: Router,
    private loginService: LoginService
  ) {
  super(route, commonService, dbOperationService, loadingState);
  }
  agendaID:string = this.route.snapshot.queryParams.agendaID;
  memberID:string = this.route.snapshot.queryParams.memberID;
  mode:string = this.route.snapshot.queryParams.mode;

  ngOnInit(): void {
    // ログインユーザーが存在するか否か
    if (!this.loginUser) {
      // ログインユーザーが存在する場合

      // 画面ロードフラグをON(ロード中状態)
      this.loadingState.loadStart();

      // ログインユーザ情報取得処理
      this.loginService.getLoginUser().subscribe((response) => {
        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3);
        // ログインユーザ情報がユーザマスタに存在するか否か
        if (this.commonService.checkNoneResponse(response)) {
          // ユーザマスタに存在しない場合

          // 不正なユーザの為、ログアウト処理
          this.loginService.logout(MESSAGE_CODE.E90000);

          // 処理を終了
          return;
        } else {
          // ユーザマスタに存在する場合

          this.loginUser = response.body[0];
          this.handleRedirect();
        }
      });
    }else{
      this.handleRedirect();
    }

  }
  /**
   * if user chose to follow an issue before logging in, redirect to c104 if follow successful,
   *    redirect to c301 if follow failed
   *    redirect to mypage b301 if not follow before logging in
   */
  private handleRedirect(){
    this.loadingState.loadStart();

    // check follow before login
    if (this.mode == '0') {
      this.handleFollow();
    //redirect c401 if proposing
    }else if(this.mode =='1'){
      this.handleProposing();
    }else if(this.mode =='2'){
      this.loadingState.loadSleepEnd(0.3);
      this.loginService.loginToPage(this.route.snapshot.queryParams.target);
    }else{
      this.baseLogin();
    }
  }

  /**
   * used to parse an url parameters segment into object
   * @param stringParam url parameters segment eg:"&id=123&mode=1"
   * @returns an object contains the parameters eg: {id:123, mode:1}
   */
  private parseStringUrlToObject(stringParam:string):any{
    let arr : any[] = stringParam.split('&');
    let result = {};
    for (let index = 0; index < arr.length; index++) {
      arr[index] = arr[index].split('=');
      result[ arr[index][0]] = arr[index][1];
    }
    return result;
  }

  /**
   * login to mypage or current page before login
   */
  private baseLogin(){
    this.loadingState.loadStart();
    if (this.router.url.split('?')[0] == '/') {
      this.loadingState.loadSleepEnd(0.3);
      this.router.navigate(['pages/platform/b301/']);
    }else{
      let urlSegment:string[] = this.router.url.split('?');
      let queryParams = {};

      if(urlSegment[1]){
        queryParams = this.parseStringUrlToObject(urlSegment[1]);
      }
      this.loadingState.loadSleepEnd(0.3);
      this.router.navigate([urlSegment[0]], {
        queryParams: queryParams
      });
    }
  }

  /**
   * follow and redirect user
   * to c104 if success
   * to c301 if failed or userlogin is the creator
   */
  private handleFollow(){
    //only user 1,2 get to follow
    if(this.loginUser.class_id == 1 || this.loginUser.class_id == 2){
      //wont follow if user created the issue
      if(this.loginUser.member_id != this.memberID){
        this.dbOperationService.insertData(ADD_AGENDA_SOLUTION_FOLLOWER, {
          agenda_id: this.agendaID,
          member_id: this.loginUser.member_id,
        })
        .subscribe((response) => {
          //remove follow detail
            if(response.body.Message == API_RESPONSE.SUCCESS){
            // redirect to c104 if follow successful
            this.loadingState.loadSleepEnd(0.3);
            this.router.navigate(['pages/platform/c104/']);
          }else{
            // redirect to c301 if failed
            this.loadingState.loadSleepEnd(0.3);
            this.router.navigate(['pages/platform/c301/' + this.agendaID]);
          }
        });
      }else{
          // redirect to c301 when is creator
          this.loadingState.loadSleepEnd(0.3);
          this.router.navigate(['pages/platform/c301/' + this.agendaID]);
      }

    }else{
      this.loadingState.loadSleepEnd(0.3);
      this.router.navigate(['pages/platform/c301/'+ this.agendaID]);
    }         
  }

  /**
   * handle issue solution proposal and redirect user
   * to c401 if not following issue
   * to c301 if following or backend respond with error
   */
  private handleProposing(){
    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(LOGIN_NOT_AGENDA_SOLUTIONS_CLOSE_LOGIC);

    // 課題・ソリューション詳細を取得
    this.dbOperationService
    .getNoTemplateDisplayData(LOGIN_NOT_AGENDA_SOLUTIONS_CLOSE_LOGIC, this.agendaID)
      .subscribe((response) => {
      // 画面ロードフラグをOFF(ロード終了)
      this.loadingState.loadSleepEnd(0.3, LOGIN_NOT_AGENDA_SOLUTIONS_CLOSE_LOGIC);
      this.loadingState.loadSleepEnd(0.3);

        if (!this.commonService.checkNoneResponse(response) && response.body[0].is_follower =='0') {
          //redirect to C401 if not following issue
          this.router.navigate(['pages/platform/c401/new'], {
            queryParams: {
              screenId: 'c401',
              agenda_id: this.agendaID
            },
          });
        } else {
          this.loadingState.loadSleepEnd(0.3, LOGIN_NOT_AGENDA_SOLUTIONS_CLOSE_LOGIC);
          this.loadingState.loadSleepEnd(0.3);
          // redirect to c301 when is following or api fails
          this.router.navigate(['pages/platform/c301/' + this.agendaID]);
        }
    });
  }
}
